export default __webpack_public_path__ + "static/media/b23ca7153082e746.93fccf191186acf28a38633931315695.svg";